import React from "react";

const Loader = ({ size = 40, color = "#4f46e5", fullPage = false }) => {
  const spinnerStyle = {
    width: size,
    height: size,
    border: `${size / 10}px solid ${color}33`,
    borderTop: `${size / 10}px solid ${color}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const wrapperStyle = fullPage
    ? {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }
    : {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
      };

  return (
    <div style={wrapperStyle}>
      <div style={spinnerStyle}></div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loader;
